module.exports = __webpack_public_path__ + "img/RU.7a8b3a7d.svg";